import {
  CheckoutBackground, CheckoutContainer, CheckoutBackContainer, CheckoutBackArrow, CheckoutBackText,
  CheckoutBottomContainer
} from "views/PaymentFlow/Checkout/Checkout.styles";
import Summary from "views/PaymentFlow/Summary/Summary";
import PaymentDetails from "views/PaymentFlow/PaymentDetails/PaymentDetails";
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "store/hooks";
import ThankYou from "views/PaymentFlow/ThankYou/ThankYou";
import ErrorPopup from "views/PaymentFlow/ErrorPopup/ErrorPopup";

function Checkout() {
  const showThankYou = useAppSelector(state => state.showThankYou.showThankYouScreen);
  const showErrorPopup = useAppSelector(state => state.error.showErrorPopup);

  const navigate = useNavigate();
  const plan = useAppSelector(state => state.subscriptionPlan);

  return (
    <CheckoutBackground>
      <CheckoutContainer>
        <CheckoutBackContainer onClick={() => navigate('/payments')}>
          <CheckoutBackArrow className={'fa-solid fa-arrow-left'}/>
          <CheckoutBackText> Back To Subscription Plans </CheckoutBackText>
        </CheckoutBackContainer>

        <CheckoutBottomContainer>
          <Summary planJson={plan}/>
          <PaymentDetails/>
        </CheckoutBottomContainer>
      </CheckoutContainer>

      {showThankYou ? <ThankYou/> : null}
      {showErrorPopup ? <ErrorPopup/> : null}
    </CheckoutBackground>
  )
}

export default Checkout;
